// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Logs from './Logs';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Logs);
